import React, { useEffect, useState } from "react";
import "./bottom.css";

export default function Bottom({ user, filter }) {
  const [projects, setProjects] = useState(user.projects);

  useEffect(() => {
    if (filter === "All") {
      setProjects(user.projects);
    } else {
      setProjects(user.projects.filter((x) => x.cat_label === filter));
    }
  }, [filter]);

  useEffect(() => {
    if (projects) {
      const window_length = document.querySelector(".bottom").offsetWidth;
      const card_length = document.querySelector(".project-card").offsetWidth;
      const noc = window_length / card_length;
      if (noc < projects.length && projects.length < 4) {
        document.querySelector(".bottom").style.overflow = "scroll";
      } else {
        document.querySelector(".bottom").style.overflow = "hidden";
      }
    }
  }, [projects]);

  return (
    <div className="bottom">
      <div
        className="bottom-slide"
        style={{
          animation:
            projects.length > 3 &&
            `${4 * projects.length}s slide infinite linear`,
        }}
      >
        {projects.map((item, index) => (
          <a href={item.link} target="_blank" className="project-card">
            <div className="project-card-black">
              <div className="project-name">{item.title}</div>
              <div className="project-label">{item.cat_label}</div>
              <div className="project-desc">{item.desc}</div>
              {item.tag && (
                <div className="project-tag">
                  <span style={{ marginRight: "10px" }}>
                    <i class="fa-solid fa-tag"></i>
                  </span>
                  {item.tag}
                </div>
              )}
              <div className="project-tech">
                <b style={{ color: "goldenrod" }}>Tech: </b>
                {item.tech}
              </div>
            </div>
            <div className="project-card-img">
              <img src={item.bg_img}></img>
            </div>
          </a>
        ))}
      </div>
      <div
        className="bottom-slide"
        style={{
          animation:
            projects.length > 3 &&
            `${4 * projects.length}s slide infinite linear`,
        }}
      >
        {projects.length > 3 &&
          projects.map((item, index) => (
            <a href={item.link} target="_blank" className="project-card">
              <div className="project-card-black">
                <div className="project-name">{item.title}</div>
                <div className="project-label">{item.cat_label}</div>
                <div className="project-desc">{item.desc}</div>
                {item.tag && (
                  <div className="project-tag">
                    <span style={{ marginRight: "10px" }}>
                      <i class="fa-solid fa-tag"></i>
                    </span>
                    {item.tag}
                  </div>
                )}
                <div className="project-tech">
                  <b style={{ color: "goldenrod" }}>Tech: </b>
                  {item.tech}
                </div>
              </div>
              <div className="project-card-img">
                <img src={item.bg_img}></img>
              </div>
            </a>
          ))}
      </div>
    </div>
  );
}
